import { Controller } from "@hotwired/stimulus"

// 目標設定モーダルの表示制御
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    if (this.dialogTarget.open) {
      this.dialogTarget.close()
    }

    this.dialogTarget.classList.add("hidden")
  }

  // 整数フィールド(step="1")でフォーカスが外れたとき小数点以下を切り捨てる
  truncateDecimal(event) {
    const input = event.target
    if (input.value !== "" && input.step === "1") {
      input.value = Math.trunc(parseFloat(input.value))
    }
  }

  // 送信時に未入力の数値フィールドを0で補完する
  fillEmptyWithZero(event) {
    const form = event.currentTarget
    form.querySelectorAll('input[type="number"]').forEach((input) => {
      if (input.value === "") {
        input.value = "0"
      }
    })
    // 時間・分入力を合算してhidden valueフィールドに反映する
    this.#combineHourGoalValues(form)
  }

  // 時間・分の入力値を時間(小数)に変換してhidden valueフィールドにセットする
  #combineHourGoalValues(form) {
    form.querySelectorAll("input[data-hour-goal-value]").forEach((hiddenInput) => {
      const container = hiddenInput.closest(".flex.items-center")
      const hoursInput = container.querySelector("input[data-hour-goal-hours]")
      const minutesInput = container.querySelector("input[data-hour-goal-minutes]")
      if (!hoursInput || !minutesInput) return

      const hours = parseInt(hoursInput.value, 10) || 0
      const minutes = Math.min(parseInt(minutesInput.value, 10) || 0, 59)
      const decimal = hours + minutes / 60.0
      hiddenInput.value = parseFloat(decimal.toFixed(4))
    })
  }

  open() {
    if (this.dialogTarget.open) return

    this.dialogTarget.classList.remove("hidden")
    this.dialogTarget.showModal()
  }

  close() {
    if (!this.dialogTarget.open) return

    this.dialogTarget.close()
    this.dialogTarget.classList.add("hidden")
  }

  // ダイアログの backdrop クリックで閉じる
  backdropClose(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  handleCancel(event) {
    event.preventDefault()
    this.close()
  }

  syncVisibility() {
    if (!this.dialogTarget.open) {
      this.dialogTarget.classList.add("hidden")
    }
  }
}
